<p-confirmDialog />
<p-toast />
<div
  *ngIf="!this.loading"
  class="container p-4 mx-auto bg-white rounded-lg shadow-lg sm:p-6 lg:p-8">
  <div class="w-full p-2 m-2">
    <!-- Header Section -->
    <div class="flex items-center justify-between">
      <div class="mb-7">
        <h1 class="mb-1 text-2xl font-semibold text-primary-200">
          View Customer
        </h1>
      </div>
    </div>
    <div class="flex items-center justify-between">
      <p-breadcrumb
        class="max-w-full"
        [model]="breadCrumbItems"
        [home]="home" />
    </div>
  </div>
  <p-card class="p-card">
    <div class="text-right">
      <p-button (click)="menu.toggle($event)" icon="pi pi-ellipsis-v" />
    </div>
    <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="first_name" class="block mb-1 font-bold">First Name</label>
      <label class="w-full">
        {{ customer()?.first_name }}
      </label>
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="last_name" class="block mb-1 font-bold">Last Name</label>
      <label>
        {{ customer()?.last_name}}
        </label>
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="email" class="block mb-1 font-bold">Email</label>
      <label>
        {{ customer()?.email}}
        </label>
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="mailing_address.line1" class="block mb-1 font-bold">
        Address
      </label>
      <label>
        {{ customer()?.mailing_address?.line1}}
        </label>  
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="mailing_address.town" class="block mb-1 font-bold">
        Town
      </label>
      <label>
        {{ customer()?.mailing_address?.town}}
        </label>
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="mailing_address.state" class="block mb-1 font-bold">
        State
      </label>
      <label>
        {{ customer()?.mailing_address?.state}}
        </label>  
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="mobile_phone" class="block mb-1 font-bold">
        Mobile Phone
      </label>
      <label>
        {{ customer()?.mobile_phone }}
        </label>  
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="status" class="block mb-1 font-bold">Status</label>
      <span [ngClass]="customer()?.status === 'ACTIVE' ? 'green' : 'red'">
        <label>
          {{ customer()?.status }}
        </label>
      </span>
    </div>
    <div class="mb-4 form-group">
      <label for="autopay" class="block text-sm font-bold text-gray-700">
        Autopay:
      </label>
      <label>
        {{ customer()?.autopay_status ?? false | boolToText }}
      </label>
    </div>
    <div class="col-span-12 mb-4 md:col-span-6">
      <label for="references" class="block mb-1 font-bold">References</label>
      <div>
        <pre [innerHTML]="customer()?.reference_keys | jsonToText"></pre>
      </div>
    </div>
  </p-card>
  <app-latest-invoice-payment
    [customer_overview]="customer"></app-latest-invoice-payment>
  <app-payment-methods [customer]="customer"></app-payment-methods>
  <app-subscription-card
    [subscriptions]="this.subscriptions!"></app-subscription-card>
  <app-asset-card [assets]="this.assets!"></app-asset-card>
  <app-invoices-card (forceRefresh)="refreshInvoices(true)" [invoices]="this.invoices!"></app-invoices-card>
  <app-payments-card [payments]="this.payments!"></app-payments-card>
</div>

<div *ngIf="this.loading" class="p-8 text-center">
  <p class="text-gray-500">Loading customer data...</p>
</div>
